import { render } from "./VideoExampleMuted.vue?vue&type=template&id=49de6faa"
import script from "./VideoExampleMuted.vue?vue&type=script&lang=js"
export * from "./VideoExampleMuted.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__